import { render, staticRenderFns } from "./SearchTemplates.vue?vue&type=template&id=d13ce862&"
import script from "./SearchTemplates.vue?vue&type=script&lang=js&"
export * from "./SearchTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports